module.exports = __webpack_public_path__ + "static/3-05ad64a17bf8dbedb3cfea41a9e41e20.jpg";